//引⼊nprogress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' //这个样式必须引⼊
NProgress.configure({     
  easing: 'ease',  // 动画⽅式
  speed: 500,  // 递增进度条的速度
  showSpinner: false, // 是否显⽰加载ico    
  trickleSpeed: 200, // ⾃动递增间隔
  minimum: 0.3 // 初始化时的最⼩百分⽐
})
export default NProgress;